import I18n from 'i18n-js'
import json from '../../../config/locales/javascript.en.json'
I18n.locale = 'en'
I18n.translations = { en: json }
global.I18n = I18n
